import React from 'react';
import { CheckCircle2, Circle, PlayCircle } from 'lucide-react';

// Vertical process map: every stage with deadline and rule; click to read its explanation
export const StageMap = ({ session, selected, onSelect, names }) => (
  <ol className="space-y-1.5" data-testid="trial-stage-map">
    {session.stages.map((st, i) => {
      const done = st.score != null && (i < session.current || session.status !== 'running');
      const active = i === session.current && session.status === 'running';
      const Icon = done ? CheckCircle2 : active ? PlayCircle : Circle;
      return (
        <li key={i}>
          <button data-testid={`trial-stage-${i}`} onClick={() => onSelect(i)}
            className={`w-full rounded-lg border px-3 py-2 text-left transition-colors ${selected === i ? 'border-amber-500 bg-amber-500/10' : 'border-slate-800 hover:border-slate-600'}`}>
            <p className="flex items-center gap-2 text-xs font-semibold text-white">
              <Icon className={`h-3.5 w-3.5 shrink-0 ${done ? 'text-emerald-400' : active ? 'text-amber-400' : 'text-slate-600'}`} />{i + 1}. {st.nombre}
              {st.score != null && <span className="ml-auto text-[10px] text-slate-400">{st.score}/10</span>}
            </p>
            <p className="mt-0.5 pl-5 text-[10px] text-slate-500 line-clamp-2">{st.plazo} · {st.norma}</p>
            {names && <p data-testid={`trial-stage-owner-${i}`} className="mt-0.5 pl-5 text-[10px] text-sky-300">{names[(session.assignments || {})[String(i)] || session.user_id]}</p>}
            {st.surprise && <p data-testid={`trial-stage-surprise-${i}`} className="mt-0.5 pl-5 text-[10px] text-red-300">Incidente sorpresa</p>}
          </button>
        </li>
      );
    })}
  </ol>
);

export const StageExplain = ({ st }) => (
  <div className="grid gap-2 sm:grid-cols-2 text-xs" data-testid="trial-stage-explain">
    {[['Qué pasa', st.que_pasa, 'text-sky-300'], ['Qué debes presentar', st.que_presentar, 'text-emerald-300'], ['Qué hará la contraparte', st.contraparte, 'text-red-300'], ['Qué suele decidir el juez', st.juez, 'text-amber-300']].map(([h, t, c]) => (
      <div key={h} className="rounded-lg border border-slate-800 bg-slate-900/70 p-2.5"><p className={`font-semibold ${c}`}>{h}</p><p className="mt-1 text-slate-300">{t}</p></div>
    ))}
  </div>
);
